const SPACE = ' ';
const COMMA = ',';

const URL_REGEX = new RegExp(
  '^(?:https?:\\/\\/)' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // ip address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+#@:,]*)*' + //port
    '(\\?[;&amp;a-z\\d%_.~+=@:,-]*)?' + // query string
    '(\\#[-a-z\\d_@:,]*)?$',
  'i',
);

const HTML_LINE_BREAK = '<br />';

export function pluralize(count, singular, plural = singular + 's') {
  count = parseInt(count, 10);
  if (count === 0) return plural;
  return count > 1 ? plural : singular;
}

export function pluralizeWithCount(...args) {
  return `${args[0]} ${pluralize(...args)}`;
}

export function toList(words, separateLast = false, conjunction = 'and') {
  const { length } = words;
  if (length === 1) {
    return words[0];
  }
  if (length === 2) {
    const separator = separateLast
      ? SPACE + conjunction + SPACE
      : COMMA + SPACE;
    return words[0] + separator + words[1];
  }
  return words.reduce(
    (list, word, i) =>
      list.concat(
        i === length - 1
          ? `${separateLast ? conjunction + SPACE : ''}${word}`
          : word + COMMA + SPACE,
      ),
    '',
  );
}

/**
 * Capitalize a word
 * @param {String} word
 * @param {Boolean} lowerRemaining
 * @return {String} Capitalized word
 * @example
 *   capitalize('fooBar') -> 'FooBar'
 */
export function capitalize(word, lowerRemaining = false) {
  const firstChar = word.slice(0, 1).toUpperCase();
  const rest = lowerRemaining ? word.slice(1).toLowerCase() : word.slice(1);
  return firstChar + rest;
}

export function toUnderscore(string) {
  return string.replace(/([A-Z]+)/g, $match => '_' + $match.toLowerCase());
}

/**
 * Validate a URL
 * @param {String} string
 * @return {Boolean}
 * @example
 *  isValidURL('http://example.com') -> true
 *  isValidURL('goocom') -> false
 */
export function isValidURL(string) {
  return URL_REGEX.test(string);
}

/**
 * Adds html breaking rule tags in place of line breaks
 * @param  {String} string the incoming string value
 * @return {String}        the incoming string formatted with breaking rules
 * @return {Null}          null object when string is empty
 */
export function formatLineBreaks(string) {
  if (string) {
    return string.replace(/\n/g, HTML_LINE_BREAK);
  }
  return null;
}

export function escapeRegex(string) {
  return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

/**
 * Validates object properties are not null or undefined
 * @param  {Object} variables the incoming object value
 * @return {Boolean}
 * @example
 *   hasNonNullValues({ searchTerm: "", ids: [] }) -> true
 * @example
 *   hasNonNullValues({ searchTerm: "", ids: null }) -> false
 */
export function hasNonNullValues(variables) {
  return Object.values(variables).every(
    value => value !== null && value !== undefined,
  );
}
